import { Checkbox } from 'antd';

/**
 * Creates a checkbox field configuration for petsitting address forms.
 * This utility function eliminates code duplication by generating the common structure
 * used across multiple field files (bathroom, equipment, kitchen, etc.).
 * @function
 *
 * @param {string|Array<string>} section - The section name (e.g., 'bathroom', 'equipment', 'kitchen')
 *   or an array for nested sections (e.g., ['parking_and_installation', 'parking'])
 * @param {string} fieldName - The field name (e.g., 'shower', 'television', 'oven', 'residence')
 * @param {Function} t - Translation function from useTranslation hook
 * @param {Object} options - Optional configuration
 * @param {boolean} options.hidden - Whether the field should be hidden
 * @param {string} options.label - Custom label (defaults to 'ghost')
 * @returns {Object} Field configuration object
 */
export const createCheckboxField = (section, fieldName, t, options = {}) => {
  const { hidden, label = 'ghost' } = options;

  // Handle nested sections (e.g., ['parking_and_installation', 'parking'])
  const sectionPath = Array.isArray(section) ? section : [section];
  const translationPath = Array.isArray(section) ? section.join('.') : section;

  const field = {
    label,
    name: [
      'petsitting_address',
      'type_of_storage_for_pensioner',
      ...sectionPath,
      fieldName
    ],
    input: (
      <Checkbox>
        {t(
          `petsittingaddress.form.type_of_storage_for_pensioner.${translationPath}.${fieldName}`
        )}
      </Checkbox>
    ),
    valuePropName: 'checked'
  };

  if (hidden !== undefined) {
    field.hidden = hidden;
  }

  return field;
};
